'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var utils = require('../utils');

var index = utils.create({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('div', {
      ref: "container",
      staticClass: "index-sidebar",
      on: {
        "touchstart": _vm.onTouchStart,
        "touchmove": function touchmove($event) {
          $event.preventDefault();
          return _vm.onTouchMove($event);
        },
        "touchend": _vm.onTouchEnd,
        "touchcancel": _vm.onTouchEnd
      }
    }, [_vm.indicator ? _c('span', {
      ref: "indicator",
      staticClass: "index-sidebar-indicator",
      style: _vm.indicatorStyle
    }, [_vm._v(_vm._s(_vm.hasAlreaySetValue ? _vm.value : _vm.prevChar))]) : _vm._e(), _vm._v(" "), _c('ul', _vm._l(_vm.alphabet, function (char) {
      return _c('li', {
        key: char,
        class: {
          active: _vm.hasAlreaySetValue ? char === _vm.value : char === _vm.prevChar
        }
      }, [_vm._v(" " + _vm._s(char) + " ")]);
    }), 0)]);
  },
  staticRenderFns: [],
  name: 'index-sidebar',
  props: {
    alphabet: {
      type: Array,
      default: function _default() {
        var alpha = [];

        for (var i = 0; i < 26; i++) {
          alpha.push(String.fromCharCode(65 + i)); // 65 => A
        }

        return alpha;
      }
    },
    indicator: {
      type: Boolean,
      default: true
    },
    value: {
      type: String
    }
  },
  data: function data() {
    return {
      isIndicatorShow: false,
      prevChar: '',
      indicatorX: 0,
      indicatorY: 0
    };
  },
  computed: {
    indicatorStyle: function indicatorStyle() {
      return {
        top: "".concat(this.indicatorY, "px"),
        left: "".concat(this.indicatorX - 80, "px"),
        display: "".concat(this.isIndicatorShow ? 'block' : 'none')
      };
    },
    containerRect: function containerRect() {
      var container = this.$refs.container;
      return container.getBoundingClientRect();
    },
    indicatorFontSize: function indicatorFontSize() {
      return parseFloat(window.getComputedStyle(this.$refs.indicator).fontSize.replace('px', ''));
    },
    containerFontSize: function containerFontSize() {
      return parseFloat(window.getComputedStyle(this.$refs.container).fontSize.replace('px', ''));
    },
    hasAlreaySetValue: function hasAlreaySetValue() {
      // 是否是双向联动组件
      return this.value !== undefined;
    }
  },
  methods: {
    getCurrentIndex: function getCurrentIndex(y) {
      var percent = Math.min(Math.max(y / this.containerRect.height, 0), 1);
      return Math.round(percent * (this.alphabet.length - 1));
    },
    getChar: function getChar(y) {
      return this.alphabet[this.getCurrentIndex(y)];
    },
    updateChar: function updateChar(x, y) {
      var currentChar = this.getChar(y);
      var prevChar = this.hasAlreaySetValue ? this.value : this.prevChar;

      if (currentChar !== prevChar) {
        if (this.hasAlreaySetValue) {
          this.$emit('input', currentChar);
        } else {
          this.prevChar = currentChar;
        }

        this.$emit('change', currentChar);

        if (this.indicator) {
          var currentIndex = this.getCurrentIndex(y);
          this.indicatorX = x;
          /* 让左边的气泡字，居中对齐右边的选中字符 */

          this.indicatorY = currentIndex * this.containerFontSize * 1.5 - // 选中字母的位置(top)
          this.indicatorFontSize * 1.25 / 2 + // 上移半个indicator的高度
          this.containerFontSize * 1.5 / 2; // 下移半个索引字母的高度

          this.isIndicatorShow = true;
        }
      }
    },
    onTouchStart: function onTouchStart(event) {
      var fixedX = event.touches[0].clientX - this.containerRect.left;
      var fixedY = event.touches[0].clientY - this.containerRect.top;
      this.updateChar(fixedX, fixedY);
    },
    onTouchMove: function onTouchMove(event) {
      var fixedX = event.touches[0].clientX - this.containerRect.left;
      var fixedY = event.touches[0].clientY - this.containerRect.top;
      this.updateChar(fixedX, fixedY);
      /**
       * IOS uc浏览器，webview bug:
       * 手指移动到 webview 边缘外，不会触发 touchend 或 touchcancel 事件
       */

      if (event.touches[0].clientY < 5 || event.touches[0].clientY > window.innerHeight) {
        this.onTouchEnd();
      }
    },
    onTouchEnd: function onTouchEnd() {
      if (!this.hasAlreaySetValue) {
        this.prevChar = '';
      }

      this.isIndicatorShow = false;
    }
  }
});

exports.default = index;
